export const ITEMS_PER_PAGE = 50;

export const agencyComponents = {
  PHOTO_SELECT: 'agencyPhotoSelect',
  NEWS_DETAIL: 'agencyNewsDetail',
  ARCHIVE_DETAIL: 'agencyArchiveDetail',
  PICK_TYPE_OF_CONTENT: 'agencyPickTypeOfContent',
  PHOTO_DOWNLOADER: 'agencyPhotoDownloader',
};

export const updatedAgencyKeywords = ['UPDATE', 'GÜNCELLEME', 'DÜZELTME', '(DÜZELTME)', 'CORRECT'];
export const regexPatternForArabicTitle = /\((?:محدث(?:\s*\d)?|مصحح)\)$/;
export const regexPatternForLatinTitle = /^(?:GÜNCELLEME|UPDATE|\(DÜZELTME\)|CORRECTION|CORRECTS)\s*\d*\s*[-–/]?\s*(.*)/i;
export const regexPatternForTurkeyCorrectionTitle = /"([^"]*)"/g;

export const agencyPhotoPickTypes = {
  AGENCY: 'agency',
  ARCHIVE: 'archive',
};

export const contentTypesToPick = {
  news: {
    contentType: 'news',
    langPath: 'content',
    langKey: 'CREATE_NEWS',
    icon: 'mdi-newspaper',
  },
  video: {
    contentType: 'video',
    langPath: 'video',
    langKey: 'CREATE_VIDEO',
    icon: 'mdi-video',
  },
  'photo-gallery': {
    contentType: 'photo-gallery',
    langPath: 'content',
    langKey: 'CREATE_PHOTO_GALLERY',
    icon: 'mdi-image-multiple',
  },
  infographic: {
    contentType: 'infographic',
    langPath: 'content',
    langKey: 'CREATE_INFOGRAPHIC',
    icon: 'mdi-information',
  },
  newspaper: {
    contentType: 'newspaper',
    langPath: 'content',
    langKey: 'CREATE_NEWSPAPER',
    icon: 'mdi-newspaper',
  },
};

export const agencyTabItems = {
  news: 0,
  video: 1,
  'photo-gallery': 2,
  infographic: 3,
  archive: 4,
};

export const AgencyNewsTypes = [
  {
    value: 1,
    langKey: 'NEWS_TYPE_IMPORTANT_DEVELOPMENT',
  },
  {
    value: 2,
    langKey: 'NEWS_TYPE_FLASH_DEVELOPMENT',
  },
  {
    value: 3,
    langKey: 'NEWS_TYPE_HOT_DEVELOPMENT',
  },
  {
    value: 4,
    langKey: 'NEWS_TYPE_STANDARD_DEVELOPMENT',
  },
];

export const AgencyUsedContent = 'used-content';
export const AgencyInappropriateContent = 'inappropriate-content';
